import React from 'react'
import Desc from '../LinkedDescription'

const sortWeight = -90

export default {
    position: {
        description: <Desc utility="position">position</Desc>,
        sortWeight
    },
    zIndex: {
        description: <Desc utility="position">z-index</Desc>,
        sortWeight
    },
    top: {
        description: <Desc utility="position">top</Desc>,
        sortWeight
    },
    right: {
        description: <Desc utility="position">right</Desc>,
        sortWeight
    },
    bottom: {
        description: <Desc utility="position">bottom</Desc>,
        sortWeight
    },
    left: {
        description: <Desc utility="position">left</Desc>,
        sortWeight
    }
}